// extracted by mini-css-extract-plugin
export default {"divider":"fsbxgTiZ1FNrn2GQ6Ugp","labelRow":"RGBDgj1wyAVXg2abAzfl","label":"Jt3Au4LC96i3HsTPoCcA","value":"mtzKkqLJoJmtLTR6vnq_","descriptionRow":"ajYR8xHHQByC2zgnvZZ7"};